import VueCookie from 'vue-cookie'

// configs
import configs from '@/config'

import store from '@/vuex/store'
import util from '@/util'

const initOptions = {
  expires: 365,
  sameSite: 'none',
  secure: true,
}

const otherRegions = ['eu']

const handleGetGoogleSlideToken = (key) => {
  return window.localStorage.getItem(key) || ''
}
const transformKey = (key) => {
  if (!key) return key

  let prefix = ''

  if (otherRegions.includes(configs.region)) {
    prefix += `${configs.region}-`
  }

  if (prefix) {
    return prefix + key
  }

  return key
}

const _getRootDomain = (domain) => {
  if (!domain) {
    return null
  }
  if (domain.includes('.ngrok')) {
    return domain
  }
  if (!util.checkWhiteLabelDomain() || configs.env !== 'local') {
    const parts = domain.split('.')
    return parts.slice(-2).join('.')
  }

  return domain
}

const setValueByDomain = (key, value, options = initOptions) => {
  if (!window.location.hostname.includes(configs.domain)) return

  if (configs.domain === 'ahaslides.eu') return

  const newOptions = {
    ...options,
    domain: configs.domain,
  }

  const newKey = transformKey(key)
  VueCookie.set(newKey, value || '', newOptions)
}

const setValue = (key, value, options = initOptions) => {
  if (store.state.isEnableAddinPowerpoint) {
    const twoYears = 60 * 60 * 24 * 365 * 2
    const expires = `max-age=${twoYears}`
    document.cookie = `${key}=${value}; path=/; ${expires}`
    return
  }
  const newKey = transformKey(key)

  VueCookie.set(newKey, value || '', options)
}

const getValue = (key) => {
  if (store?.state?.isEnableAddinPowerpoint) {
    const name = `${key}=`
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }
  if (configs.integrationPlatform === 'GoogleSlide') {
    return handleGetGoogleSlideToken(key)
  }
  const newKey = transformKey(key)
  const value = VueCookie.get(newKey)
  if (value === 'true') {
    return true
  }

  if (value === 'false') {
    return false
  }

  return value
}

const handleRemoveGoogleSlideToken = (key) => {
  window.localStorage.removeItem(key)
}

const deleteValue = (key) => {
  const newKey = transformKey(key)
  if (configs.integrationPlatform === 'GoogleSlide') {
    handleRemoveGoogleSlideToken(key)
  }
  VueCookie.delete(newKey)

  if (window.location.hostname.includes(configs.domain)) {
    VueCookie.delete(newKey, {
      domain: configs.domain,
    })
  }
}

const setTokenValue = (key, value, options = initOptions) => {
  if (util.isEuOrWhiteLabel()) {
    setValue(key, value, options)

    return
  }

  const newKey = transformKey(key)
  VueCookie.set(newKey, value, {
    ...options,
    domain: _getRootDomain(configs.domain),
    path: '/',
  })
}

const deleteTokenValue = (key = 'ahaToken') => {
  deleteValue(key)

  if (util.isEuOrWhiteLabel()) return

  const newKey = transformKey(key)

  VueCookie.delete(newKey, {
    domain: _getRootDomain(configs.domain),
    path: '/',
  })
}

const deleteCookieGoogleSlide = (name) => {
  handleRemoveGoogleSlideToken(name)
}

export default {
  deleteValue,
  setValue,
  setValueByDomain,
  getValue,
  setTokenValue,
  deleteTokenValue,
  deleteCookieGoogleSlide,
}
